export const ALL_INTENTS = 'ALL_INTENTS';
export const SET_SELECTED_AGENT = 'SET_SELECTED_AGENT';
